// extracted by mini-css-extract-plugin
export default {"avatar":"styles_avatar__fF+0y","text":"styles_text__Sb2v3"};